import apiClient from '@/api/axiosConfig';

export type Interview = {
  token: string;
  imageUrl?: string;
  description?: string;
  deliveredAt?: string;
  ownerId?: number;
  quotationToken?: string;
};

export type ProtagonistInfo = {
  firstName: string;
  lastName?: string;
  nickname?: string;
  description?: string;
  photoUrl?: string;
  photo?: string | File;
};

async function getInterview(interviewToken: string) {
  const response = await apiClient.get<Interview>(`/interviews/${interviewToken}`);
  return response.data;
}

async function getProtagonistInfo(interviewToken: string) {
  const response = await apiClient.get<ProtagonistInfo>(
    `/interviews/${interviewToken}/protagonist_info`,
  );
  return response.data;
}

async function createProtagonistInfo(protagonistInfo: ProtagonistInfo) {
  const response = await apiClient.post<ProtagonistInfo>(
    `/interviews/create_interview`,
    protagonistInfo,
  );
  return response.data;
}

async function updateProtagonistInfo(
  interviewToken: string,
  protagonistInfo: ProtagonistInfo,
) {
  const formData = new FormData();
  const formKeys = Object.keys(protagonistInfo);

  // Add quotation attributes
  if (formKeys.includes('firstName')) {
    formData.append(
      'interview[quotation_attributes][protagonist_first_name]',
      protagonistInfo.firstName ?? '',
    );
  }
  if (formKeys.includes('lastName')) {
    formData.append(
      'interview[quotation_attributes][protagonist_last_name]',
      protagonistInfo.lastName ?? '',
    );
  }
  if (formKeys.includes('nickname')) {
    formData.append(
      'interview[quotation_attributes][protagonist_nickname]',
      protagonistInfo.nickname ?? '',
    );
  }

  // Add other fields
  if (protagonistInfo.photoUrl) {
    formData.append('interview[photo_url]', protagonistInfo.photoUrl);
  }
  if (protagonistInfo.photo) {
    formData.append('interview[photo]', protagonistInfo.photo);
  }
  if (formKeys.includes('description')) {
    formData.append('interview[description]', protagonistInfo.description ?? '');
  }

  const response = await apiClient.put<ProtagonistInfo>(
    `/interviews/${interviewToken}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json, image/*',
      },
    },
  );
  return response.data;
}

export { getInterview, getProtagonistInfo, updateProtagonistInfo, createProtagonistInfo };
